import PropTypes from 'prop-types';
import React, { useState, useCallback } from 'react';
import styled from 'styled-components';
import { useEditor, ReactEditor } from 'slate-react';
import { StyledTextButton, StyledPopup } from './styles';
import LinkForm from './LinkForm';
import TextPopupWrapper from './TextPopupWrapper';
import { Edit as EditIcon } from '@icons/common';

const Link = ({ children, attributes, element }) => {
  const editor = useEditor();
  const [isOpenForm, setIsOpenForm] = useState(false);
  const [isOpenPopup, setIsOpenPopup] = useState(false);

  const toggleIsOpenForm = useCallback(() => {
    setIsOpenForm(prevIsOpenForm => !prevIsOpenForm);
  }, []);

  const toggleIsOpenPopup = useCallback(() => {
    setIsOpenPopup(prevIsOpenPopup => !prevIsOpenPopup);
  }, []);

  const handleLinkClick = useCallback(event => {
    event.stopPropagation();

    toggleIsOpenPopup();
  });

  const handleEditClick = useCallback(event => {
    event.stopPropagation();

    toggleIsOpenForm();
    toggleIsOpenPopup();
  }, []);

  const handleClearClick = useCallback(event => {
    event.stopPropagation();

    const path = ReactEditor.findPath(editor, element);
    editor.unwrapLink({
      editor,
      options: {
        at: path,
      },
    });
    toggleIsOpenPopup();
  }, []);

  const handleSubmit = useCallback(({ url }) => {
    const path = ReactEditor.findPath(editor, element);
    editor.setLink({
      editor,
      url,
      options: {
        at: path,
      },
    });
    toggleIsOpenPopup();
  }, []);

  const { url } = element;

  return (
    <StyledLink onClick={handleLinkClick} href={url} {...attributes}>
      <TextPopupWrapper
        element={element}
        editor={editor}
        isOpen={isOpenPopup}
        onClose={toggleIsOpenPopup}
      >
        <StyledLinkPopup>
          <StyledLink href={url} target="_blank" rel="noopener noreferrer">
            {url}
          </StyledLink>
          <StyledPopupControl>
            <StyledPopupEdit onClick={handleEditClick} />
            <StyledTextButton onClick={handleClearClick}>
              Очистить ссылку
            </StyledTextButton>
          </StyledPopupControl>
        </StyledLinkPopup>
      </TextPopupWrapper>
      <StyledPopup isOpen={isOpenForm}>
        {isOpenForm && (
          <LinkForm
            defaultUrl={url}
            onSubmit={handleSubmit}
            onClose={toggleIsOpenForm}
          />
        )}
      </StyledPopup>
      {children}
    </StyledLink>
  );
};

Link.propTypes = {
  children: PropTypes.node,
  attributes: PropTypes.elementType,
  element: PropTypes.shape({
    url: PropTypes.string,
  }).isRequired,
};

Link.defaultProps = {
  children: null,
  attributes: [],
};

const StyledLink = styled.a`
  display: inline;
  max-width: 300px;
  position: relative;
  font-family: 'Backpack', sans-serif;
  font-size: 14px;
  line-height: 17px;
  color: #007aff;
  text-overflow: ellipsis;
`;

const StyledLinkPopup = styled.span`
  display: flex;
  flex-direction: column;
  cursor: default;
  flex-wrap: wrap;
  background: white;
  border-radius: 5px;
  padding: 3px 10px 6px 10px;
  top: calc(100% - 70px);
  z-index: 100;
  box-shadow: 0 10px 15px 0 rgba(196, 194, 182, 0.9),
    0 1px 2px 0 rgba(210, 208, 197, 0.9);

  a {
    cursor: pointer;
    overflow: hidden;
  }
`;

const StyledPopupEdit = styled(EditIcon)`
  width: 17px;
  height: 17px;
  cursor: pointer;
  padding: 3px 0 0 3px;
  position: relative;
  top: 2px;

  path {
    stroke: #007aff;
  }
`;

const StyledPopupControl = styled.span`
  white-space: nowrap;
`;

export default Link;
